import { Form, Input, Modal, Switch, Typography, Space } from "antd";
import { useState } from "react";
import { PlusOutlined, InboxOutlined, CheckCircleOutlined } from "@ant-design/icons";
import ManageBinService from "../../../services/ManageBinService";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";

const { Text } = Typography;

const AddBin = ({ userData, addBinModal, setIsModalOpen, onAddBin }) => {
  const [form] = Form.useForm();
  const [status, setStatus] = useState("Active");
  const [loading, setLoading] = useState(false);

  const handleChange = (checked) => {
    const newStatus = checked ? "Active" : "In-Active";
    setStatus(newStatus);
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const formData = {
        ...values,
        bin_status: status,
        bin_added_by: userData.su_id,
      };

      console.log("Form Data:", formData);

      const response = await ManageBinService.add_bin(formData);

      console.log("Server Response:", response);
      ResponseMessage.success({ message: response.message });
      onAddBin(formData);
      setIsModalOpen(false);
      form.resetFields();
      setStatus("Active");
    } catch (error) {
      console.log("Error submitting form:", error);
      ResponseMessage.error({ message: error });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
    setStatus("Active");
  };

  return (
    <>
      <style>
        {`
          .modern-bin-modal .ant-modal-content {
            border-radius: 20px;
            overflow: hidden;
            padding: 0;
          }

          .modern-bin-modal .ant-modal-header {
            border-bottom: 1px solid #f1f5f9;
            background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
            padding: 18px 24px;
            margin-bottom: 0;
          }

          .modern-bin-modal .ant-modal-title {
            font-size: 18px;
            font-weight: 700;
            color: #1e293b;
          }

          .modern-bin-modal .ant-modal-body {
            padding: 24px;
            background: #ffffff;
          }

          .modern-bin-modal .ant-modal-footer {
            padding: 16px 24px 20px;
            border-top: 1px solid #f1f5f9;
          }

          .modern-bin-modal .ant-form-item-label > label {
            font-weight: 600;
            color: #334155;
          }

          .modern-bin-modal .ant-input {
            border-radius: 10px;
            padding: 10px 12px;
            border: 1px solid #dbe2ea;
          }

          .modern-bin-modal .ant-input:focus,
          .modern-bin-modal .ant-input-focused {
            border-color: #7c3aed;
            box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.08);
          }

          .modern-bin-modal .status-box {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            border: 1px solid #e2e8f0;
            border-radius: 14px;
            padding: 14px 16px;
          }

          .modern-bin-modal .status-pill {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 6px 12px;
            border-radius: 999px;
            font-size: 12px;
            font-weight: 700;
          }

          .modern-bin-modal .status-pill.active {
            background: #ecfdf5;
            color: #065f46;
            border: 1px solid #a7f3d0;
          }

          .modern-bin-modal .status-pill.inactive {
            background: #fef2f2;
            color: #991b1b;
            border: 1px solid #fecaca;
          }

          .modern-bin-modal .ant-switch.ant-switch-checked {
            background: #7c3aed;
          }

          .modern-bin-modal .primary-btn {
            background: linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%);
            border: none;
            border-radius: 8px;
            font-weight: 500;
            box-shadow: 0 2px 8px rgba(124, 58, 237, 0.2);
          }

          .modern-bin-modal .primary-btn:hover {
            background: linear-gradient(135deg, #6d28d9 0%, #4c1d95 100%) !important;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
          }
        `}
      </style>

      <Modal
        className="modern-bin-modal"
        title={
          <Space>
            <PlusOutlined style={{ color: "#7c3aed" }} />
            <span>Add New Bin</span>
          </Space>
        }
        open={addBinModal}
        onOk={() => form.submit()}
        onCancel={handleCancel}
        okText="Submit"
        confirmLoading={loading}
        okButtonProps={{ className: "primary-btn" }}
        cancelText="Cancel"
        width={520}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <div
            style={{
              marginBottom: 20,
              padding: "14px 16px",
              borderRadius: 14,
              background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
              border: "1px solid #e2e8f0",
            }}
          >
            <Space align="start">
              <InboxOutlined style={{ color: "#7c3aed", fontSize: 18, marginTop: 2 }} />
              <div>
                <Text strong style={{ color: "#1e293b", display: "block" }}>
                  Bin Information
                </Text>
                <Text style={{ color: "#64748b", fontSize: 13 }}>
                  Enter the bin details below to create a new bin.
                </Text>
              </div>
            </Space>
          </div>

          <Form.Item
            label="Enter Bin Name"
            name="bin_name"
            rules={[{ required: true, message: "Please enter the bin name!" }]}
          >
            <Input placeholder="Enter bin name" />
          </Form.Item>

          <Form.Item
            label="Enter Capacity in Kgs"
            name="bin_capacity"
            rules={[
              { required: true, message: "Please enter the capacity!" },
              { pattern: /^[0-9]+$/, message: "Capacity must be a number!" },
            ]}
          >
            <Input placeholder="Enter bin capacity" />
          </Form.Item>

          <Form.Item required label="Status" name="bin_status">
            <div className="status-box">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 12,
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <div
                    className={`status-pill ${
                      status === "Active" ? "active" : "inactive"
                    }`}
                  >
                    <CheckCircleOutlined />
                    {status}
                  </div>
                  <div style={{ marginTop: 8 }}>
                    <Text style={{ color: "#64748b", fontSize: 13 }}>
                      Toggle the switch to set the bin status.
                    </Text>
                  </div>
                </div>

                <Switch
                  checkedChildren="Active"
                  unCheckedChildren="In-Active"
                  checked={status === "Active"}
                  onChange={handleChange}
                />
              </div>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddBin;